"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2380],{

/***/ 791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42041);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88700);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 67349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ authModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(77712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(30839);
;// CONCATENATED MODULE: ./containers/auth/authViews.tsx



const SignUp = /*#__PURE__*/ (0,react.lazy)(()=>Promise.all(/* import() */[__webpack_require__.e(8), __webpack_require__.e(9290), __webpack_require__.e(719), __webpack_require__.e(3085), __webpack_require__.e(9405), __webpack_require__.e(7385), __webpack_require__.e(8038), __webpack_require__.e(9541)]).then(__webpack_require__.bind(__webpack_require__, 45709)));
const SignIn = /*#__PURE__*/ (0,react.lazy)(()=>Promise.all(/* import() */[__webpack_require__.e(8), __webpack_require__.e(9290), __webpack_require__.e(719), __webpack_require__.e(3085), __webpack_require__.e(9405), __webpack_require__.e(7385), __webpack_require__.e(206)]).then(__webpack_require__.bind(__webpack_require__, 20206)));
const ForgotPassword = /*#__PURE__*/ (0,react.lazy)(()=>Promise.all(/* import() */[__webpack_require__.e(8), __webpack_require__.e(9290), __webpack_require__.e(719), __webpack_require__.e(3085), __webpack_require__.e(9405), __webpack_require__.e(7385), __webpack_require__.e(8038), __webpack_require__.e(6238)]).then(__webpack_require__.bind(__webpack_require__, 27711)));
function AuthViews() {
    const [currentView, setCurrentView] = (0,react.useState)("SIGN_IN");
    const handleChangeView = (0,react.useCallback)((view)=>{
        setCurrentView(view);
    }, []);
    const renderView = (view)=>{
        switch(view){
            case "SIGN_IN":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {
                        onChangeView: handleChangeView
                    })
                });
            case "SIGN_UP":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUp, {
                        onChangeView: handleChangeView
                    })
                });
            case "FORGOT_PASSWORD":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassword, {
                        onChangeView: handleChangeView
                    })
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {
                        onChangeView: handleChangeView
                    })
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: renderView(currentView)
    });
}
/* harmony default export */ var authViews = (AuthViews);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(9120);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(68864);
// EXTERNAL MODULE: ./components/confirmationModal/confirmationModal.tsx
var confirmationModal = __webpack_require__(35105);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./containers/modal/modal.tsx
var modal = __webpack_require__(49613);
;// CONCATENATED MODULE: ./containers/auth/authModal.tsx









function AuthModal() {
    const { t  } = (0,es/* useTranslation */.$G)();
    const { authModalOpen , closeAuthModal , isConfirmNeedForCloseModal  } = (0,auth_context/* useAuth */.a)();
    const isMobile = (0,useMediaQuery/* default */.Z)("(max-width:599px)");
    const [isOpenConfirm, openConfirm, closeConfirm] = (0,useModal/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal["default"], {
                fullScreen: isMobile,
                closable: isMobile,
                open: authModalOpen,
                onClose: ()=>{
                    if (isConfirmNeedForCloseModal.current) {
                        openConfirm();
                        return;
                    }
                    closeAuthModal();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        padding: "2rem",
                        margin: "auto 0",
                        width: {
                            sm: "350px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(authViews, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmationModal/* default */.Z, {
                open: isOpenConfirm,
                handleClose: closeConfirm,
                title: t("sure.to.end.auth"),
                onSubmit: ()=>{
                    closeAuthModal();
                    closeConfirm();
                }
            })
        ]
    });
}
/* harmony default export */ var authModal = (AuthModal);


/***/ })

}]);